export default "__VITE_ASSET__ofB3LT9C__"